// Path: ./src/app/components/Button/styled.ts
import styled from "styled-components";

interface TitleProps {
  isLoading?: boolean;
  titleStyleCss?: string;
}
export const Title = styled.div<TitleProps>`
  font-size: 16px;
  margin-left: ${(props) => (props?.isLoading ? "5px" : "0px")};
  ${(props) => {
    return props?.titleStyleCss ? props.titleStyleCss : "";
  }}
`;

interface ButtonProps {
  buttonStyleCss?: string;
}
export const Button = styled.button<ButtonProps>`
  width: 100%;
  max-width: 380px;
  background-color: #ff8038;
  border: none;
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: #ff8038;
    box-shadow: 0 0 0 1px #ff8038;
  }

  ${(props) => {
    return props?.buttonStyleCss ? props.buttonStyleCss : "";
  }}
`;
